import { Localization } from 'connex-cds';
import { isPendingStatusCode } from '../../../../../query-hooks/load-assignments';
import { StatusChip } from './styles';
import { RowActionsMenu } from './RowActionsMenu';

const { useShortDateTime: shortDateTime } = Localization || {};

export const getShortDateTime = (date, timeZone = null) => {
  if (!date) return null;
  const { getShortDateTime } = shortDateTime({ overrideTimeZone: timeZone });
  return getShortDateTime(date);
};

export const useTableColumns = ({ onView, onActivate, onDeactivate, onCreateTicket } = {}) => {
  const translateMessage = Localization.useTranslateMessage();
  const { timeZone } = Localization.useLocalizationContext();

  return [
    {
      field: 'scheduledYardTime',
      headerAlign: 'center',
      align: 'center',
      renderCell: params => getShortDateTime(params?.value ? new Date(params.value) : null, timeZone),
      headerName: translateMessage('gridHeader_loadTime'),
      minWidth: 140,
      flex: 1,
      hideable: false,
      editable: false,
    },
    {
      field: 'orderId',
      headerAlign: 'center',
      align: 'center',
      headerName: translateMessage('gridHeader_orderNumber'),
      minWidth: 120,
      flex: 1,
      hideable: false,
      editable: false,
    },
    {
      field: 'loadNumber',
      headerAlign: 'center',
      align: 'center',
      headerName: translateMessage('gridHeader_loadNumber'),
      minWidth: 100,
      flex: 1,
      hideable: false,
      editable: false,
      renderCell: params => (params?.value != null ? `${translateMessage('loadLabel')} ${params.value}` : ''),
    },
    {
      field: 'statusCode',
      headerAlign: 'center',
      align: 'center',
      headerName: translateMessage('gridHeader_status'),
      minWidth: 120,
      flex: 1,
      hideable: false,
      editable: false,
      renderCell: params => {
        const isActive = Boolean(params?.row?.isActive);
        const isPending = !isActive && isPendingStatusCode(params?.value);
        const label = isActive
          ? translateMessage('loadAssignment_statusActive')
          : isPending
          ? translateMessage('loadAssignment_statusPending')
          : params?.value;
        return (
          <StatusChip
            statusType={isActive ? 'active' : isPending ? 'pending' : 'default'}
            label={label}
            size="small"
            variant="outlined"
          />
        );
      },
    },
    {
      field: 'productName',
      headerAlign: 'center',
      align: 'center',
      headerName: translateMessage('gridHeader_product'),
      minWidth: 140,
      flex: 1,
      hideable: false,
      editable: false,
    },
    {
      field: 'customerName',
      headerAlign: 'center',
      align: 'center',
      headerName: translateMessage('gridHeader_customer'),
      minWidth: 140,
      flex: 1,
      hideable: false,
      editable: false,
    },
    {
      field: 'actions',
      headerName: '',
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      hideable: false,
      editable: false,
      align: 'center',
      headerAlign: 'center',
      width: 56,
      minWidth: 56,
      maxWidth: 56,
      renderCell: params => (
        <RowActionsMenu
          assignment={params?.row}
          onView={onView}
          onActivate={onActivate}
          onDeactivate={onDeactivate}
          onCreateTicket={onCreateTicket}
        />
      ),
    },
  ];
};
